import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}
export function Input({
  className = '',
  error,
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-667">
      <input className={`
          flex h-10 sm:h-11 w-full rounded-lg border-2 border-amber-200 bg-white px-3 sm:px-4 py-2 text-sm sm:text-base text-stone-800
          placeholder:text-stone-400
          focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500
          disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-stone-50
          transition-all duration-200
          print:h-8 print:text-sm print:border-stone-400 print:rounded-md
          ${error ? 'border-red-500 focus:ring-red-500 bg-red-50/30' : ''}
          ${className}
        `} {...props} data-id="element-668" />
      {error && <p className="mt-1.5 text-xs sm:text-sm text-red-600 font-medium print:hidden" data-id="element-669">
          {error}
        </p>}
    </div>;
}